<div class="login-wrapper">

  <!-- ── Painel esquerdo: imagem 70% ── -->
  <div class="image-panel">
    <img src="assets/imgs/bg-login.png" alt="GDIAS Marmoraria" class="bg-img">
    <div class="img-overlay"></div>
    <div class="brand-caption">
      <div class="brand-mark">
        <span class="brand-name">GDIAS</span>
        <span class="brand-divider"></span>
        <span class="brand-sub">MARMORARIA</span>
      </div>
      <p class="brand-tagline">Excelência em mármore e granito</p>
    </div>
  </div>

  <!-- ── Painel direito: formulário 30% ── -->
  <div class="form-panel">
    <div class="form-inner">

      <div class="system-brand">
        <p class="system-label">Sistema de Gestão</p>
        <h2 class="system-name">KALI <span>ERP</span></h2>
      </div>

      <form (ngSubmit)="login()" autocomplete="off">

        <div class="field">
          <label for="username">Usuário</label>
          <div class="field-input">
            <i class="bi bi-person field-icon"></i>
            <input
              type="text"
              id="username"
              name="username"
              data-testid="login-usuario"
              placeholder="usuario@empresa"
              [ngModel]="username()"
              (ngModelChange)="username.set($event)"
              required
              autocomplete="username"
              [attr.aria-invalid]="mostrarErroFormato()"
              aria-describedby="username-help"
            >
          </div>
          @if (mostrarErroFormato()) {
            <small id="username-help" class="field-error" role="alert" data-testid="login-formato-erro">{{ mensagemFormato }}</small>
          } @else {
            <small id="username-help" class="field-help">Use o formato usuario@empresa.</small>
          }
        </div>

        <div class="field">
          <label for="password">Senha</label>
          <div class="field-input">
            <i class="bi bi-lock field-icon"></i>
            <input
              [type]="showPassword() ? 'text' : 'password'"
              id="password"
              name="password"
              data-testid="login-senha"
              placeholder="Digite sua senha"
              [ngModel]="password()"
              (ngModelChange)="password.set($event)"
              required
              autocomplete="current-password"
            >
            <button type="button" class="toggle-pw" (click)="showPassword.set(!showPassword())" tabindex="-1">
              <i [class]="showPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </button>
          </div>
        </div>

        <button type="submit" class="btn-enter" data-testid="login-entrar" [disabled]="formatoInvalido()">
          <span>Entrar</span>
          <i class="bi bi-arrow-right-circle"></i>
        </button>

      </form>

      <p class="login-footer">KALI &copy; 2026 &mdash; Todos os direitos reservados</p>
    </div>
  </div>

</div>